import { render } from "./Error404.vue?vue&type=template&id=42861b89&scoped=true"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"

import "./Error404.vue?vue&type=style&index=0&id=42861b89&scoped=true&lang=css"

import exportComponent from "/builds/alex-yonge-photography/alex-yonge-photographs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42861b89"]])

export default __exports__